import tippy from 'tippy.js';
import IMask from 'imask';
import moment from 'moment';
import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";
flatpickr.localize(German)

$(document).ready(function () {

    $("#submitButton").hide();

    //Tippy
    tippy('.tt', {
        content(reference) {
            const id = reference.getAttribute('data-template');
            const template = document.getElementById(id);
            return template.innerHTML;
        },
        appendTo: document.body,
        allowHTML: true,
        trigger: 'click',
        role: 'tooltip',
        interactive: true,
        arrow: true,
        maxWidth: 320,
        offset: [0, 15]
    });

    /**
     * Input select
     */
    window.onSelectOption = function (element) {
        // Set selected option value to hidden select input value
        const hiddenSelectInput = element.parentNode.parentNode.querySelector('.input-select-value')
        hiddenSelectInput.value = element.getAttribute('data-value')

        // Set active state to selected option
        const selectOptions = element.parentNode.querySelectorAll('.input-select-option-item')
        selectOptions.forEach(option => {
            option.classList.remove("selected");
        })
        element.classList.add("selected");

        // Close select options after selecting
        element.parentNode.parentNode.querySelector('.input-select').checked = false;

        // Show selected option on input field
        const selectInputLabel = element.parentNode.parentNode.querySelector('.input-select-label')
        const selectInputLabelValue = selectInputLabel.querySelector('.input-select-label-value')
        selectInputLabelValue.innerHTML = element.innerHTML
        selectInputLabel.classList.add("selected");
    }

    // /**
    //  * preselection Input select
    //  */
    // const preSelections = document.querySelectorAll('.input-select-option')
    // preSelections.forEach(preSelection => {
    //     const preOptions = preSelection.querySelectorAll('.input-select-option-item');
    //
    //     preOptions.forEach(preOption => {
    //         if (preSelection.dataset.value === preOption.dataset.value) {
    //             const preLabel = preSelection.parentNode.parentNode.querySelector('.input-select-label');
    //             const preValue = preLabel.querySelector('.input-select-label-value');
    //             preValue.innerHTML = preOption.outerText;
    //             preOption.classList.add("selected");
    //             preLabel.classList.add("selected");
    //         } else {
    //             return;
    //         }
    //     })
    // });


    /**
     * Range Slider
     */

    // Add scale for all range sliders with class scale
    let rangeSliderElements = document.querySelectorAll(".range-slider");
    rangeSliderElements.forEach(element => {
        if (element.classList.contains('scale')) {
            const rangeSlider = element.querySelector('.range-slider-input')
            const maxValue = rangeSlider.getAttribute("max")
            const stepValue = rangeSlider.getAttribute("step")

            if (maxValue % stepValue === 0) {
                const scale = document.createElement('div');
                scale.classList.add('range-slider-scale');

                let strokes = document.createDocumentFragment();
                const numberOfStrokes = (maxValue / stepValue) + 1

                for (let x = 0; x < numberOfStrokes; x++) {
                    const scaleStroke = document.createElement('div');
                    scaleStroke.classList.add('range-slider-scale-stroke');
                    strokes.appendChild(scaleStroke);
                }

                scale.appendChild(strokes);

                const target = element.querySelector('.range-slider-progress');
                target.parentNode.insertBefore(scale, target.nextSibling);
            } else {
                console.error('Skala kann nicht generiert werden, da step size kein Vielfaches von max value ist.')
            }
        }
    });

    window.onChangeRangeSlide = function (element) {
        // Show range slider value
        const prevElement = element.previousElementSibling

        if (prevElement.classList.contains('range-slider-value')) {
            prevElement.firstElementChild.innerHTML = element.value
        } else {
            prevElement.previousElementSibling.firstElementChild.innerHTML = element.value
        }

        // Adjust range slider progress bar according to input value
        const maxValue = element.getAttribute("max")
        const currentValue = element.value

        element.nextElementSibling.style.width = (currentValue * 100) / maxValue + "%";
    };

    /**
     * Datepicker Flatpickr
     */

    // const datepickerElements = document.querySelectorAll('.datepicker')
    const datepickerElements = document.querySelectorAll('.flatpickr')
    datepickerElements.forEach(picker => {
        flatpickr(picker, {
            // inline: true,
            // wrap: true,
            // appendTo: picker,
            // minDate: "today",
            // position: "above left",
            // monthSelectorType: "static",
            // allowInput: true,
            // positionElement: picker,
            dateFormat: "d.m.Y",
            parseDate: (datestr, format) => {
                if (moment(datestr, 'DD.MM.YYYY', true).isValid()) {
                    removeErrorBox("date")
                    return moment(datestr, 'DD.MM.YYYY', true).toDate();
                } else {
                    addErrorBox("date", "Bitte geben Sie ein Datum im Format DD.MM.YYYY ein.");
                    return moment().toDate()
                }
            },
            onOpen() {
                removeErrorBox("date")
            }
        });
    })

    /**
     * Progress Action Bar
     */
    const progressActionBars = document.querySelectorAll('.progress-action-bar')
    progressActionBars.forEach(bar => {
        // Check if progress action bar is inside form stepper
        // If true do stuff like automatically set max step number and show step content according to current step
        if (bar.closest('.form-stepper') !== null) {
            // Show form-stepper step content according to current step
            // For that check form-stepper content placement
            const currentStep = bar.querySelector('.current-step').innerHTML

            let formStepperContent;
            if (bar.closest('.form-stepper').firstElementChild.classList.contains('form-stepper-content')) {
                formStepperContent = bar.previousElementSibling
            } else if (bar.closest('.form-stepper').lastElementChild.classList.contains('form-stepper-content')) {
                formStepperContent = bar.nextElementSibling
            } else {
                console.error('Form stepper content not placed correctly')
            }

            if (formStepperContent) {
                // Set max number of steps according to number of form-stepper steps
                const numberOfFormSteps = formStepperContent.querySelectorAll('.form-stepper-step').length
                bar.querySelector('.total-steps').innerHTML = numberOfFormSteps.toString()
                // Show step content according to current step
                formStepperContent.querySelector('#step-' + currentStep).style.display = 'block'
                formStepperContent.querySelector('#step-' + currentStep).style.visibility = 'visible'
                // Show current Step title in progress action bar according to current step
                bar.querySelector('.step-selection-title').innerHTML = formStepperContent.querySelector('#step-' + currentStep).getAttribute('data-title')
            }
        }
    })

    // Set progress bar width according to current step
    const progressActionBarsProgress = document.querySelectorAll('.progress-action-bar-progress')
    progressActionBarsProgress.forEach(bar => {
        const currentStep = parseInt(bar.parentNode.querySelector('.current-step').innerHTML)
        const totalSteps = parseInt(bar.parentNode.querySelector('.total-steps').innerHTML)
        const progress = currentStep * (100 / totalSteps)
        bar.style.width = progress + '%'
    })

    window.goToNextStep = function (element) {
        const currentStep = parseInt(element.parentNode.parentNode.querySelector('.current-step').innerHTML)
        const totalSteps = parseInt(element.parentNode.parentNode.querySelector('.total-steps').innerHTML)
        const nextStep = currentStep + 1
        const progress = nextStep * (100 / totalSteps)

        if (validateForm(currentStep)) {
            hideButtons(nextStep)

            if (currentStep < totalSteps) {
                element.parentNode.parentNode.querySelector('.current-step').innerHTML = nextStep
                element.parentNode.parentNode.querySelector('.progress-action-bar-progress').style.width = progress + '%'

                // Check if progress action bar is inside form stepper
                let formStepperContent;
                if (element.closest('.form-stepper') !== null) {
                    if (element.closest('.form-stepper').firstElementChild.classList.contains('form-stepper-content')) {
                        formStepperContent = element.parentNode.parentElement.previousElementSibling
                    } else if (element.closest('.form-stepper').lastElementChild.classList.contains('form-stepper-content')) {
                        formStepperContent = element.parentNode.parentElement.nextElementSibling
                    } else {
                        console.error('Form stepper content not placed correctly')
                    }

                    if (formStepperContent) {
                        // Show step content according to current step (and hide prev content)
                        formStepperContent.querySelector('#step-' + nextStep).style.display = 'block'
                        formStepperContent.querySelector('#step-' + nextStep).style.visibility = 'visible'
                        formStepperContent.querySelector('#step-' + currentStep).style.display = 'none'
                        formStepperContent.querySelector('#step-' + currentStep).style.visibility = 'hidden'

                        // Show current Step title in progress action bar according to current step
                        element.parentNode.parentNode.querySelector('.step-selection-title').innerHTML = formStepperContent.querySelector('#step-' + nextStep).getAttribute('data-title')
                    }
                }

                $("#submitButton").hide();
                $("#weiterButton").show();
            }

            if (nextStep < totalSteps) {
                $("#submitButton").hide();
                $("#weiterButton").show();
            }

            if (nextStep === totalSteps) {
                $("#submitButton").show();
                $("#weiterButton").hide();
            }
        }
    }

    window.goToPrevStep = function (element) {
        const currentStep = parseInt(element.parentNode.parentNode.querySelector('.current-step').innerHTML)
        const totalSteps = parseInt(element.parentNode.parentNode.querySelector('.total-steps').innerHTML)
        const nextStep = currentStep - 1
        const progress = nextStep * (100 / totalSteps)
        hideButtons(nextStep)

        if (currentStep > 1) {
            element.parentNode.parentNode.querySelector('.current-step').innerHTML = nextStep
            element.parentNode.parentNode.querySelector('.progress-action-bar-progress').style.width = progress + '%'

            let formStepperContent;
            if (element.closest('.form-stepper') !== null) {
                if (element.closest('.form-stepper').firstElementChild.classList.contains('form-stepper-content')) {
                    formStepperContent = element.parentNode.parentElement.previousElementSibling
                } else if (element.closest('.form-stepper').lastElementChild.classList.contains('form-stepper-content')) {
                    formStepperContent = element.parentNode.parentElement.nextElementSibling
                } else {
                    console.error('Form stepper content not placed correctly')
                }

                if (formStepperContent) {
                    // Show step content according to current step (and hide prev content)
                    formStepperContent.querySelector('#step-' + nextStep).style.display = 'block'
                    formStepperContent.querySelector('#step-' + nextStep).style.visibility = 'visible'
                    formStepperContent.querySelector('#step-' + currentStep).style.display = 'none'
                    formStepperContent.querySelector('#step-' + currentStep).style.visibility = 'hidden'

                    // Show current Step title in progress action bar according to current step
                    element.parentNode.parentNode.querySelector('.step-selection-title').innerHTML = formStepperContent.querySelector('#step-' + nextStep).getAttribute('data-title')
                }
            }
        }

        if (nextStep < totalSteps) {
            $("#submitButton").hide();
            $("#weiterButton").show();
        }

        if (nextStep === totalSteps) {
            $("#submitButton").show();
            $("#weiterButton").hide();
        }
    }

    window.cancelProgress = function (element) {
        hideButtons(0);
        location.reload(true);
    }

    /**
     * Accordion Tabs
     */
    const labels = document.querySelectorAll(".accordiontab-label");
    const tabs = document.querySelectorAll(".accordiontab-button");
    const accordionTab = document.querySelector(".accordiontab");

    tabs.forEach(tab => {
        const tabData = tab.dataset.actabId;

        labels.forEach(label => {
            const itemdata = label.parentElement.dataset.actabId;

            if (tabData === itemdata) {
                label.innerHTML = tab.innerHTML;
            }
        });
    });

    function toggleShow() {
        const target = this;
        const item = target.classList.contains("accordiontab-button")
            ? target
            : target.parentElement;
        const group = item.dataset.actabGroup;
        const id = item.dataset.actabId;

        tabs.forEach(tab => {
            if (tab.dataset.actabGroup === group) {
                if (tab.dataset.actabId === id) {
                    tab.classList.add("accordiontab-button--active");
                } else {
                    tab.classList.remove("accordiontab-button--active");
                }
            }
        });

        if (target.parentElement.classList.contains("accordiontab-item--active")) {
            target.parentElement.classList.remove("accordiontab-item--active")
        } else {
            labels.forEach(label => {
                const tabItem = label.parentElement;

                if (tabItem.dataset.actabGroup === group) {
                    if (tabItem.dataset.actabId === id) {
                        tabItem.classList.add("accordiontab-item--active");
                    } else {
                        tabItem.classList.remove("accordiontab-item--active");
                    }
                }
            });
        }
    }
    
    if (accordionTab) {
        const accordiontabButtons = document.querySelectorAll(".accordiontab-button");
        const accordiontabItems = document.querySelectorAll(".accordiontab-item");

        function responsiveAccTabs(x) {
    
            if (x.matches) {
            } else {
                accordiontabButtons.forEach(accordiontabButton => {
                    accordiontabButton.classList.remove("accordiontab-button--active");
                });
                accordiontabButtons[0].classList.add("accordiontab-button--active");
    
                accordiontabItems.forEach(accordiontabItem => {
                    accordiontabItem.classList.remove("accordiontab-item--active");
                });
                accordiontabItems[0].classList.add("accordiontab-item--active");
            }
        }
    
        var x = window.matchMedia("(max-width: 599px)")
        responsiveAccTabs(x);
        x.addListener(responsiveAccTabs);
    }

    labels.forEach(label => {
        label.addEventListener("click", toggleShow);
    });

    tabs.forEach(tab => {
        tab.addEventListener("click", toggleShow);
    });

    //validate form
    function validateForm(step) {
        var valid = true;

        //step1
        if (step == 1) {
            var ticketArt = document.getElementsByName("lottery_ticket")[0].value;
            var ticketCount = document.getElementById("lottery_ticket_count").value;
            var date = document.getElementsByName("date")[0].value;

            if (ticketArt == "" || ticketArt == false) {
                valid = false;
            }

            //losanzahl is only required if shown
            var losArtValue = "";
            if (document.querySelector('input[name="lottery_ticket"]:checked') != null) {
                losArtValue = document.querySelector('input[name="lottery_ticket"]:checked').value;
            }

            //check additional text field if active
            if (losArtValue == 1279) {
                if ($("#dropdown2").val() == "") {
                    addErrorBox("dropdown2");
                    valid = false;
                }

                //show extra field
                $("#e1l").show();
                $("#e1").show();
            } else {
                //hide extra field
                $("#e1l").hide();
                $("#e1").hide();
            }
            if (losArtValue == 1282) {
                if ($("#dropdown5").val() == "") {
                    addErrorBox("dropdown5");
                    valid = false;
                }

                //show extra field
                $("#e2l").show();
                $("#e2").show();
            } else {
                //hide extra field
                $("#e2l").hide();
                $("#e2").hide();
            }
            if (losArtValue == 1284) {
                if ($("#dropdown7").val() == "") {
                    addErrorBox("dropdown7");
                    valid = false;
                }

                $("#e3l").show();
                $("#e3").show();
            } else {
                $("#e3l").hide();
                $("#e3").hide();
            }

            if (losArtValue != 28742) {
                //hide losanzahl
                $("#s2l").show();
                $("#s2").show();
                if (ticketCount == "" || ticketCount == false) {
                    addErrorBox("lottery_ticket_count");
                    valid = false;
                }
            } else {
                //hide losanzahl
                $("#s2l").hide();
                $("#s2").hide();
            }

            if (date == "" || date == false) {
                addErrorBox("date");
                valid = false;
            }

        } else if (step == 2) { // step 2

            if ($('#geschlecht').val() == "") {
                addErrorBox("geschlecht");
                valid = false;
            }

            if ($('#Vorname').val() == "") {
                addErrorBox("Vorname");
                valid = false;
            }

            if (!validateName($('#Vorname').val())) {
                addErrorBox("Vorname", 'Bitte geben Sie einen gültigen Vornamen ein.');
                valid = false;
            }

            if ($('#Nachname').val() == "") {
                addErrorBox("Nachname");
                valid = false;
            }

            if (!validateName($('#Nachname').val())) {
                addErrorBox("Nachname", 'Bitte geben Sie einen gültigen Nachnamen ein.');
                valid = false;
            }

            if ($('#Strasse').val() == "") {
                addErrorBox("Strasse");
                valid = false;
            }

            if (!validateName($('#Strasse').val())) {
                addErrorBox("Strasse", 'Bitte geben Sie einen gültigen Straßennamen ein.');
                valid = false;
            }

            if ($('#Hausnummer').val() == "") {
                addErrorBox("Hausnummer");
                valid = false;
            }

            if ($('#PLZ').val() == "" || $('#PLZ').val().match(/[0-9]{5}/g) == null) {
                if (!validatePLZ($('#PLZ').val())) {
                    addErrorBox("PLZ", "Bitte geben Sie eine gültige PLZ ein.");
                } else {
                    addErrorBox("PLZ");
                }

                valid = false;
            }

            if ($('#Ort').val() == "") {
                addErrorBox("Ort");
                valid = false;
            }

            if (!validateName($('#Ort').val())) {
                addErrorBox("Ort", 'Bitte geben Sie einen gültigen Ortsnamen ein.');
                valid = false;
            }

            if ($('#Telefon').val() != "" && !validateTelefon($('#Telefon').val())) {
                addErrorBox("Telefon", 'Bitte geben Sie eine gültige Telefonnummer ein.');
                valid = false;
            }

            if ($('#Email').val() == "" || !$('#Email').val().match(/.{1,}@.{1,}/g)) {
                if ($('#Email').val() == "") {
                    addErrorBox("Email");
                } else {
                    addErrorBox("Email", "Bitte geben Sie eine gültige Email ein!");
                }

                valid = false;
            }

            // Entferne Whitespace von der Eingabe
            var abbuchungskontoIban = $('#abbuchungskonto-iban').val().replace(/\s+/g, '');
            var sparkontoIban = $('#sparkonto-iban').val().replace(/\s+/g, '');
            var gewinnkontoIban = $('#gewinnkonto-iban').val().replace(/\s+/g, '');

            if (abbuchungskontoIban === "" || abbuchungskontoIban.includes(ibanRules) === false || !validateIABN(abbuchungskontoIban)) {
                if (abbuchungskontoIban === "") {
                    addErrorBox("abbuchungskonto-iban");
                }
                if (abbuchungskontoIban.includes(ibanRules) === false) {
                    addErrorBox("abbuchungskonto-iban", "Es dürfen nur Kunden mit einem Konto teilnehmen.");
                }
                if (!validateIABN(abbuchungskontoIban)) {
                    addErrorBox("abbuchungskonto-iban", "Bitte geben Sie eine gültige IBAN ein.");
                }

                valid = false;
            }

            if ($('#abbuchungskonto-bic').val() == "") {
                addErrorBox("abbuchungskonto-bic");
                valid = false;
            }

            if (sparkontoIban === "" || sparkontoIban.includes(ibanRules) === false || !validateIABN(sparkontoIban)) {
                if (sparkontoIban === "") {
                    addErrorBox("sparkonto-iban");
                }
                if (sparkontoIban.includes(ibanRules) === false) {
                    addErrorBox("sparkonto-iban", "Es dürfen nur Kunden mit einem Konto teilnehmen.");
                }
                if (!validateIABN(sparkontoIban)) {
                    addErrorBox("sparkonto-iban", "Bitte geben Sie eine gültige IBAN ein.");
                }

                valid = false;
            }

            if ($('#sparkonto-bic').val() == "") {
                addErrorBox("sparkonto-bic");
                valid = false;
            }

            if (gewinnkontoIban === "" || gewinnkontoIban.includes(ibanRules) === false || !validateIABN(gewinnkontoIban)) {
                if (gewinnkontoIban === "") {
                    addErrorBox("gewinnkonto-iban");
                }
                if (gewinnkontoIban.includes(ibanRules) === false) {
                    addErrorBox("gewinnkonto-iban", "Es dürfen nur Kunden mit einem Konto teilnehmen.");
                }
                if (!validateIABN(gewinnkontoIban)) {
                    addErrorBox("gewinnkonto-iban", "Bitte geben Sie eine gültige IBAN ein.");
                }

                valid = false;
            }

            if ($('#gewinnkonto-bic').val() == "") {
                addErrorBox("gewinnkonto-bic");
                valid = false;
            }

            document.getElementById("s4").innerHTML = $('#geschlecht').val();
            document.getElementById("s4b").innerHTML = $('#title').val();
            document.getElementById("s14").innerHTML = $('#abbuchungskonto-bic').val();
            document.getElementById("s16").innerHTML = $('#sparkonto-bic').val();
            document.getElementById("s18").innerHTML = $('#gewinnkonto-bic').val();
            document.getElementById("e1").innerHTML = $('#dropdown2').val();
            document.getElementById("e2").innerHTML = $('#dropdown5').val();
            document.getElementById("e3").innerHTML = $('#dropdown7').val();

        } else if (step == 3) {//step 3

            var check4 = document.getElementsByName("check4");
            if (typeof check4 !== 'undefined' && typeof check4[0] !== 'undefined') check4 = check4[0].checked;
            var check5 = document.getElementsByName("check5");
            if (typeof check5 !== 'undefined' && typeof check5[0] !== 'undefined') check5 = check5[0].checked;
            var check2 = document.getElementsByName("check2");
            if (typeof check2 !== 'undefined' && typeof check2[0] !== 'undefined') check2 = check2[0].checked;
            var check3 = document.getElementsByName("check3");
            if (typeof check3 !== 'undefined' && typeof check3[0] !== 'undefined') check3 = check3[0].checked;
            var checkvvi = document.getElementsByName("checkvvi");
            if (typeof checkvvi !== 'undefined' && typeof checkvvi[0] !== 'undefined') checkvvi = checkvvi[0].checked;

            $(".pdfcheck").each(function () {
                var checkpdf = document.getElementById(this.id);

                if ($("#" + this.id).hasClass("required")) {
                    if (typeof checkpdf !== 'undefined') checkpdf = checkpdf.checked;

                    if (checkpdf == "" || checkpdf == false) {
                        addErrorCheckbox(this.id);
                        valid = false;
                    }
                }

            });

            // var checkpdf = document.getElementsByName("check_100");
            // if(typeof checkpdf !== 'undefined' && typeof checkpdf[0] !== 'undefined') checkpdf = checkpdf[0].checked;

            if (check4 == "" || check4 == false) {
                addErrorCheckbox("check4");
                valid = false;
            }
            if (check5 == "" || check5 == false) {
                addErrorCheckbox("check5");
                valid = false;
            }
            if (check2 == "" || check2 == false) {
                addErrorCheckbox("check2");
                valid = false;
            }
            if (check3 == "" || check3 == false) {
                addErrorCheckbox("check3");
                valid = false;
            }
            if (checkvvi == "" || checkvvi == false) {
                addErrorCheckbox("checkvvi");
                valid = false;
            }


        }

        return valid; // return the valid status
    }

    function validateName(input) {
        return !!input.match(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u)
    }

    function validateNumbers(input) {
        return !!input.match(/^[0-9]+$/);
    }
    function validatePLZ(input) {
        return !!input.match(/^(?!01066|99999)(0[1-9]\d{3}|[1-9]\d{4})$/);
    }

    function validateTelefon(input) {
        // return !!input.match(/\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/);
        return !!input.match(/^[\+]?[(]?[0-9 ]{3}[)]?[-\s\.]?[0-9 ]{3}[-\s\.]?[0-9 ]{4,6}$/);
    }

    function validateIABN(input) {
        // Entferne Whitespace von der Eingabe
        var iban = input.replace(/\s+/g, '');

        // Prüfe Länge der IBAN
        if (iban.length === 22) {
            // Validiere IBAN
            return /^DE[0-9]{20}$/.test(iban) || /^de[0-9]{20}$/.test(iban);
        }
        return false
    }

    //field listener
    if ($("input[name=lottery_ticket]:checked").val() == undefined) {
        $("input[name=lottery_ticket]:first").attr('checked', true);

        var losArtLabel = "";
        var losArtValue = $("input[name=lottery_ticket]:checked").val();

        if (losArtValue == 1278) {
            losArtLabel = "Los mit zufälliger Endziffer";
        } else if (losArtValue == 1279) {
            losArtLabel = "Los mit bestimmter Endziffer";
        } else if (losArtValue == 1280) {
            losArtLabel = " 10 Lose mit fortlaufenden Endziffern 0-9.";
        } else if (losArtValue == 1281) {
            losArtLabel = "Jahres-Geschenk-Los mit zufälliger Endziffer";
        } else if (losArtValue == 1282) {
            losArtLabel = "Jahres-Geschenk-Los mit bestimmter Endziffer";
        } else if (losArtValue == 2097) {
            losArtLabel = "Ich bin bereits Kunde und möchte weitere Lose kaufen.";
        } else if (losArtValue == 1283) {
            losArtLabel = "Jahres-Geschenk-Los mit fortlaufenden Endziffern (0-9)";
        } else if (losArtValue == 1284) {
            losArtLabel = "Spar-Geschenk-Los mit zufälliger Endziffer mit Abfrage über Laufzeit des Loses";
        } else if (losArtValue == 2176) {
            losArtLabel = "Los-Abo (monatlicher Dauerauftrag)";
        } else if (losArtValue == 28742) {
            losArtLabel = "Aufstocken auf 10 Lose mit fortlaufenden Endziffern 0-9.";
        }
        const losArtLabelID = document.getElementById("s1");

        if (losArtLabelID) {
            losArtLabelID.innerHTML = losArtLabel;
        }
        // document.getElementById("s1").innerHTML = losArtLabel;

    }
    $("input[name=lottery_ticket]").change(function () {
        var losArtLabel = "";
        var losArtValue = $("input[name=lottery_ticket]:checked").val();

        if (losArtValue == 1278) {
            losArtLabel = "Los mit zufälliger Endziffer";
        } else if (losArtValue == 1279) {
            losArtLabel = "Los mit bestimmter Endziffer";
        } else if (losArtValue == 1280) {
            losArtLabel = " 10 Lose mit fortlaufenden Endziffern 0-9.";
        } else if (losArtValue == 1281) {
            losArtLabel = "Jahres-Geschenk-Los mit zufälliger Endziffer";
        } else if (losArtValue == 1282) {
            losArtLabel = "Jahres-Geschenk-Los mit bestimmter Endziffer";
        } else if (losArtValue == 2097) {
            losArtLabel = "Ich bin bereits Kunde und möchte weitere Lose kaufen.";
        } else if (losArtValue == 1283) {
            losArtLabel = "Jahres-Geschenk-Los mit fortlaufenden Endziffern (0-9)";
        } else if (losArtValue == 1284) {
            losArtLabel = "Spar-Geschenk-Los mit zufälliger Endziffer mit Abfrage über Laufzeit des Loses";
        } else if (losArtValue == 2176) {
            losArtLabel = "Los-Abo (monatlicher Dauerauftrag)";
        } else if (losArtValue == 28742) {
            losArtLabel = "Aufstocken auf 10 Lose mit fortlaufenden Endziffern 0-9.";
        }
        document.getElementById("s1").innerHTML = losArtLabel;
    });

    $('#dropdown2').change(function () {
        document.getElementById("e1").innerHTML = $('#dropdown2').val();
    });
    $('#dropdown2').keyup(function () {
        removeErrorBox("dropdown2");
    });

    $('#dropdown5').change(function () {
        document.getElementById("e2").innerHTML = $('#dropdown5').val();
    });
    $('#dropdown5').keyup(function () {
        removeErrorBox("dropdown5");
    });

    $('#dropdown7').change(function () {
        document.getElementById("e3").innerHTML = $('#dropdown7').val();
    });
    $('#dropdown7').parent().children("label").click(function () {
        removeErrorBox("dropdown7");
    });

    $('#lottery_ticket_count').change(function () {
        document.getElementById("s2").innerHTML = $('#lottery_ticket_count').val();
    });
    $('#lottery_ticket_count').keyup(function () {
        removeErrorBox("lottery_ticket_count");
    });

    $('input[name="date"]').change(function () {
        document.getElementById("s3").innerHTML = $('#date').val();
    });
    $('input[name="date"]').click(function () {
        removeErrorBox("date");
    });

    $('#geschlechtBox').click(function () {
        removeErrorBox("geschlecht");
    });

    $('#Vorname').change(function () {
        document.getElementById("s5").innerHTML = $('#Vorname').val();
    });
    $('#Vorname').keyup(function () {
        removeErrorBox("Vorname");
    });

    $('#Nachname').change(function () {
        document.getElementById("s6").innerHTML = $('#Nachname').val();
    });
    $('#Nachname').keyup(function () {
        removeErrorBox("Nachname");
    });

    $('#Strasse').change(function () {
        document.getElementById("s7").innerHTML = $('#Strasse').val();
    });
    $('#Strasse').keyup(function () {
        removeErrorBox("Strasse");
    });

    $('#Hausnummer').change(function () {
        document.getElementById("s8").innerHTML = $('#Hausnummer').val();
    });
    $('#Hausnummer').keyup(function () {
        removeErrorBox("Hausnummer");
    });

    $('#PLZ').change(function () {
        document.getElementById("s9").innerHTML = $('#PLZ').val();
    });
    $('#PLZ').keyup(function () {
        removeErrorBox("PLZ");
    });

    $('#Ort').change(function () {
        document.getElementById("s10").innerHTML = $('#Ort').val();
    });
    $('#Ort').keyup(function () {
        removeErrorBox("Ort");
    });

    if ($('#Telefon').val() !== "") $("#s11").show();
    $('#Telefon').change(function () {
        if ($('#Telefon').val() !== "") {
            document.getElementById("s11").innerHTML = $('#Telefon').val();
            $("#s11l").show();
            $("#s11").show();
        } else {
            $("#s11l").hide();
            $("#s11").hide();
        }
    });

    $('#Telefon').keyup(function () {
        removeErrorBox("Telefon");
    });

    $('#Email').change(function () {
        document.getElementById("s12").innerHTML = $('#Email').val();
    });
    $('#Email').keyup(function () {
        removeErrorBox("Email");
    });

    var abbuchungskonto = document.getElementById('abbuchungskonto-iban');
    var sparkonto = document.getElementById('sparkonto-iban');
    var gewinnkonto = document.getElementById('gewinnkonto-iban');
    var maskOptions = {
        mask: 'aa00 0000 0000 0000 0000 00'
    };

    if (abbuchungskonto || sparkonto || gewinnkonto) {
        var abbuchungskontoMask = IMask(abbuchungskonto, maskOptions);
        var sparkontoMask = IMask(sparkonto, maskOptions);
        var gewinnkontoMask = IMask(gewinnkonto, maskOptions);
    }

    $('#abbuchungskonto-iban').change(function () {
        document.getElementById("s13").innerHTML = $('#abbuchungskonto-iban').val();
    });
    $('#abbuchungskonto-iban').keyup(function () {
        removeErrorBox("abbuchungskonto-iban");
    });

    if ($('#abbuchungskonto-bic').val() !== "") {
        $("#s14l").show();
        $("#s14").show();
    }
    $('#abbuchungskonto-bic').change(function () {
        if ($('#abbuchungskonto-bic').val() !== "") {
            document.getElementById("s14").innerHTML = $('#abbuchungskonto-bic').val();
            $("#s14l").show();
            $("#s14").show();
        } else {
            $("#s14l").hide();
            $("#s14").hide();
        }
    });
    $('#abbuchungskonto-bic').keyup(function () {
        removeErrorBox("abbuchungskonto-bic");
    });

    $('#sparkonto-iban').change(function () {
        document.getElementById("s15").innerHTML = $('#sparkonto-iban').val();
    });
    $('#sparkonto-iban').keyup(function () {
        removeErrorBox("sparkonto-iban");
    });

    if ($('#sparkonto-bic').val() !== "") {
        $("#s16l").show();
        $("#s16").show();
    }
    $('#sparkonto-bic').change(function () {
        if ($('#sparkonto-bic').val() !== "") {
            document.getElementById("s16").innerHTML = $('#sparkonto-bic').val();
            $("#s16l").show();
            $("#s16").show();
        } else {
            $("#s16l").hide();
            $("#s16").hide();
        }
    });
    $('#sparkonto-bic').keyup(function () {
        removeErrorBox("sparkonto-bic");
    });

    $('#gewinnkonto-iban').change(function () {
        document.getElementById("s17").innerHTML = $('#gewinnkonto-iban').val();
    });
    $('#gewinnkonto-iban').keyup(function () {
        removeErrorBox("gewinnkonto-iban");
    });

    if ($('#gewinnkonto-bic').val() !== "") {
        $("#s18l").show();
        $("#s18").show();
    }
    $('#gewinnkonto-bic').change(function () {
        if ($('#gewinnkonto-bic').val() !== "") {
            document.getElementById("s18").innerHTML = $('#gewinnkonto-bic').val();
            $("#s18l").show();
            $("#s18").show();
        } else {
            $("#s18l").hide();
            $("#s18").hide();
        }
    });
    $('#gewinnkonto-bic').keyup(function () {
        removeErrorBox("gewinnkonto-bic");
    });

    $('#check4Label').click(function () {
        removeErrorCheckbox("check4");
    });
    $('#check5Label').click(function () {
        removeErrorCheckbox("check5");
    });
    $('#check2Label').click(function () {
        removeErrorCheckbox("check2");
    });
    $('#check3Label').click(function () {
        removeErrorCheckbox("check3");
    });
    $('#checkvviLabel').click(function () {
        removeErrorCheckbox("checkvvi");
    });
    $(".pdfcheck").each(function () {
        $(this).click(function () {
            removeErrorCheckbox(this.id);
        });
    });


    function addErrorBox(field, errorMsg = "") {
        const ltc = document.querySelector("[id='" + field + "']")
        let msg = "Bitte füllen Sie das Feld aus!";
        ltc.parentElement.classList.add('error')

        if (errorMsg != "") msg = errorMsg

        if (!ltc.parentElement.parentElement.querySelector('.form-field-error')) {
            const error = document.createElement("div");
            error.innerHTML = msg
            error.classList.add('form-field-error')
            error.classList.add('form-error')
            ltc.parentNode.parentNode.insertBefore(error, ltc.parentNode.nextSibling)
        } else {
            ltc.parentElement.parentElement.querySelector('.form-field-error').innerHTML = msg
        }
    }

    function addErrorCheckbox(field) {
        const ltc = document.querySelector("[name='" + field + "']")
        ltc.parentElement.classList.add('error')

        if (!ltc.parentElement.parentElement.querySelector('.form-error')) {
            const error = document.createElement("span");
            error.innerHTML = "Bitte füllen Sie das Feld aus!"
            error.classList.add('form-error')
            ltc.parentNode.parentNode.insertBefore(error, ltc.parentNode.nextSibling)
        } else {
            ltc.parentElement.parentElement.querySelector('.form-error').innerHTML = "Bitte füllen Sie das Feld aus!"
        }
    }

    function removeErrorBox(field) {
        const ltc = document.querySelector("[id='" + field + "']")
        ltc.parentElement.classList.remove('error')

        if (ltc.parentElement.parentElement.querySelector('.form-field-error')) {
            const element = ltc.parentElement.parentElement.querySelector('.form-field-error')
            element.remove();
        }
    }

    function removeErrorCheckbox(field) {
        const ltc = document.querySelector("[name='" + field + "']")
        ltc.parentElement.classList.remove('error')

        if (ltc.parentElement.parentElement.querySelector('.form-error')) {
            const element = ltc.parentElement.parentElement.querySelector('.form-error')
            element.remove();
        }
    }

    function hideButtons(step) {
        if (step > 1) $("#btnPrev").css("display", "inline-flex");
        else $("#btnPrev").css("display", "");
        // if (step > 1) $("#btnPrev").show();
        // else $("#btnPrev").hide();
    }
});
